var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PlayerControllerApiFactory } from "@/apis/player-management";
import InfinityTable from "@/components/Infinitytable";
import { LocalStorageKeys } from "@/constants/localStorage";
import { Card, Divider, message } from "@atom/ui-kit";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { columns } from "./PlayerManagement.columns";
import PlayerManagementFilterSpace from "./PlayerManagement.filters";
var DEFAULT_PAGE_SIZE = 50;
var PlayerManagement = function () {
    var t = useTranslation().t;
    var navigate = useNavigate();
    var _a = useState({
        tenant: localStorage.getItem(LocalStorageKeys.TENANT) || "wisegaming",
        limit: DEFAULT_PAGE_SIZE,
        requestType: "all",
    }), reqParams = _a[0], setReqParams = _a[1];
    var _b = useState([]), allPlayers = _b[0], setAllPlayers = _b[1];
    var _c = useState([]), filteredPlayers = _c[0], setFilteredPlayers = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var fetchAllPlayers = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, players, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    return [4 /*yield*/, PlayerControllerApiFactory().playersGet({
                            limit: reqParams.limit,
                        })];
                case 1:
                    response = (_a.sent());
                    players = response.data.data.players;
                    setAllPlayers(players);
                    setFilteredPlayers(players);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    message.error("Failed to fetch all players");
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var fetchFilteredPlayers = function (playerName) { return __awaiter(void 0, void 0, void 0, function () {
        var response, filtered, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setLoading(true);
                    return [4 /*yield*/, PlayerControllerApiFactory().playersTenantTenantNameUsernameGet({
                            username: playerName,
                            tenant: localStorage.getItem(LocalStorageKeys.TENANT),
                        })];
                case 1:
                    response = (_a.sent());
                    if (response.data.data.player) {
                        setFilteredPlayers([response.data.data.player]);
                    }
                    else {
                        filtered = allPlayers.filter(function (player) { return player.username.toLowerCase().includes(playerName.toLowerCase()); });
                        setFilteredPlayers(filtered);
                    }
                    return [3 /*break*/, 4];
                case 2:
                    error_2 = _a.sent();
                    message.error("Failed to fetch filtered players");
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleSearch = function (values) {
        if (values.playerName) {
            fetchFilteredPlayers(values.playerName);
        }
        else {
            setFilteredPlayers(allPlayers);
        }
    };
    var handleEdit = function (key, tenant) {
        navigate("/player-management/".concat(key, "?tenant=").concat(tenant));
    };
    useEffect(function () {
        fetchAllPlayers();
    }, []);
    return (_jsxs(Card, { style: { padding: "20px 0", height: "80vh" }, children: [_jsx(PlayerManagementFilterSpace, { onSearch: handleSearch }), _jsx(Divider, {}), _jsx(InfinityTable, { size: "small", pagination: false, columns: columns(handleEdit, t), dataSource: filteredPlayers || [], loading: loading })] }));
};
export default PlayerManagement;
